import {FACTION_CONFIGS_IMPLEMENTED} from '../../configs/factions';

/**
 * Фракция, которую сейчас можно забрать в магазине бесплатно по акции
 * (цена сбита до нуля при ненулевой исходной — см. originalPriceCrystals в
 * configs/factions.js), и которая у игрока еще не открыта. Для подсказки в
 * модалке «Недостаточно фракций»: до четырех фракций для рейтинга новичку
 * не хватает одной-двух, а одну можно взять даром — стоит сказать об этом
 * прямо там. Люди в счет не идут: у них исходной цены нет, они открыты всем.
 * Акция кончится — из конфига уйдет нулевая цена, и подсказка исчезнет сама.
 *
 * @param {Array<{id: string, isAvailable: boolean}>} availableFactions - фракции из профиля
 * @returns {Object|null} конфиг фракции или null
 */
export const getFreeFactionOffer = (availableFactions) => {
  const unlockedFactionIds = new Set(
    (availableFactions || []).filter((faction) => faction.isAvailable).map((faction) => faction.id)
  );
  return FACTION_CONFIGS_IMPLEMENTED.find((faction) => (
    faction.priceCrystals === 0
    && faction.originalPriceCrystals > 0
    && !unlockedFactionIds.has(faction.id)
  )) || null;
};
